import { createFileRoute } from '@tanstack/react-router'
import TeamTab from '@/pages/admin/TeamTab'

export const Route = createFileRoute('/_authenticated/admin/team')({
  component: TeamTab,
})
